import script from "./baseInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./baseInfo.vue?vue&type=script&setup=true&lang=js"

import "./baseInfo.vue?vue&type=style&index=0&id=73a745c3&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73a745c3"]])

export default __exports__